import React, { useEffect, useRef, useState } from "react";

type TrackInformationProps = {
  duration: string;
  trackName: string;
  artist: string;
  currentTime: string;
};

const TrackInformation: React.FC<TrackInformationProps> = ({
  duration,
  trackName,
  artist,
  currentTime,
}) => {
  const textRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    if (textRef.current && containerRef.current) {
      const textWidth = textRef.current.scrollWidth;
      const containerWidth = containerRef.current.clientWidth;
      setIsScrolling(textWidth > containerWidth);
    }
  }, [trackName, artist, duration, currentTime]);

  return (
    <div ref={containerRef} className="track-info-container">
      <div className={`track-info-wrapper ${isScrolling ? "scrolling" : ""}`}>
        <div ref={textRef} className="track-info-content">
          Duration: {currentTime}/{duration} 🎧 {trackName} - {artist}
        </div>
        <div className="track-info-content">
          Duration: {currentTime}/{duration} 🎧 {trackName} - {artist}
        </div>
      </div>
    </div>
  );
};

export default TrackInformation;
